export enum ProceduresValueSets {
  BillableProcedureCodes = "http://quiltedhealth.com/fhir/ValueSet/billable-cpt",
  CPT = "http://www.ama-assn.org/go/cpt/vs",
}
